package terraultima.game

/**
 * What any interface must implement. Implementations may block (a terminal waiting on a keypress) or
 * not (a web frontend resuming a suspended session) — the game flow only requires that
 * [chooseMotive], [reviewSetup] and [present] eventually return.
 */
interface Frontend {

    /** Called once, before anything else, so the frontend can pull state on demand. */
    fun attach(session: SessionInfo) {}

    /** @return index into [motives]. [default] is the pre-selected one. */
    fun chooseMotive(motives: List<MotiveView>, default: Int): Int

    /** Show the fixed expedition. Returns when the player is ready to launch. */
    fun reviewSetup(setup: SetupView)

    /** @return the [OptionView.number] the player picked. Must be an available option. */
    fun present(decision: DecisionView): Int

    /**
     * A decision that was taken WITHOUT asking this frontend — a bot-driven run being watched.
     * Default is silence, so an interface that only supports play need not implement it.
     */
    fun observed(decision: DecisionView, chosen: String) {}

    /** The result of a gamble the player took. */
    fun outcome(text: String)

    fun yearReport(report: YearReportView)

    fun ending(ending: EndingView)
}
